import {Pipe, PipeTransform} from '@angular/core';
import IGalleryItem from '../interfaces/IGalleryItem'

@Pipe({name: 'filterGalleryItemsByAlbumID', pure: false})
export class FilterGalleryItemsByAlbumID implements PipeTransform {
    transform(galleryItem: IGalleryItem[], albumId: any = 1): any {
        if (galleryItem) {
            let res = [];
            if (albumId === "All")
                return galleryItem;
            galleryItem.forEach((galleryItem) => {
                if (galleryItem.albumId === albumId) {
                    res.push(galleryItem);
                }
            })
            return res;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pipes/filterGalleryItemsByAlbumID.pipe.ts